import React, { createContext, useContext, useState, useCallback } from 'react';

const GradeUpdatesContext = createContext();

export const GradeUpdatesProvider = ({ children }) => {
  const [gradeUpdates, setGradeUpdates] = useState({});

  const updateGrade = useCallback((studentId, deliveryName, grade) => {
    const key = `${studentId}-${deliveryName}`;
    setGradeUpdates((prev) => ({
      ...prev,
      [key]: grade,
    }));
  }, []);

  const getGrade = useCallback(
    (studentId, deliveryName, originalGrade) => {
      const key = `${studentId}-${deliveryName}`;
      return gradeUpdates[key] !== undefined
        ? gradeUpdates[key]
        : originalGrade;
    },
    [gradeUpdates]
  );

  return (
    <GradeUpdatesContext.Provider
      value={{ updateGrade, getGrade, gradeUpdates }}
    >
      {children}
    </GradeUpdatesContext.Provider>
  );
};

export const useGradeUpdates = () => {
  const context = useContext(GradeUpdatesContext);
  if (!context) {
    return {
      updateGrade: () => {},
      getGrade: (studentId, deliveryName, originalGrade) => originalGrade,
      gradeUpdates: {},
    };
  }
  return context;
};
